import { computed, observable, override, makeObservable } from 'mobx';
import SurveyQuestion from './SurveyQuestion';
import {Employee} from 'main/stores/employees';
import {QAAnswer} from '../questions';
import {generateAnonymousEmployee} from 'shared/tools';

class SurveyAnswer extends QAAnswer {
  content;
  employee = new Employee(generateAnonymousEmployee());
  _relations = {
    employee: Employee,
    question: SurveyQuestion
  };

  constructor(other) {
    super();

    makeObservable(this, {
      content: observable,
      employee: observable,
      updateValue: override,
      value: computed
    });

    this.merge(other);
  }

  updateValue(value) {
    this.content = value;
  }

  get value() {
    return this.content;
  }
}

export default SurveyAnswer;
